import React, { useState, useEffect } from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import { withRouter } from "react-router-dom";
import useStyles from "./styles";

const BreadCrumb = (props) => {
  const classes = useStyles();
  const { breadcrumb } = props;
  const [navPath, setNavPath] = useState("");
  function handleClick(event) {
    props.history.push(`/app/dashboard`);
  }

  function handleNav(item) {
    console.log("item", item);
    switch (item) {
      case "providers":
        props.history.push(`/app/providers`);
        break;

      case "claims":
      case "claims-CSR":
      case "fr-CSR":
        if (breadcrumb.includes("fr-CSR")) {
          props.history.push(`/app/claims/fr-CSR`);
        } else {
          props.history.push(`/app/claims/claims-CSR`);
        }
        break;
      case "policy":
        props.history.push(`/app/policy/policy-CSR`);
        break;

      case "workflow":
        props.history.push(`/app/workflow`);
        break;
      case "claims-payments":
        props.history.push(`/app/claims/claims-payments`);
        break;
      case "agents":
        props.history.push(`/app/agents`);
        break;
      case "return-batch":
        break;
      case "account":
        break;
      case "money-batch":
        break;
      default:
        if (breadcrumb.includes("diary") || breadcrumb.includes("workflow")) {
          props.history.push(`/app/dashboard`);
        } else {
          props.history.push(`/app/policy/policy-CSR`);
        }
        break;
    }
  }

  useEffect(() => {
    let string = breadcrumb.split("/");
    setNavPath(string);
  }, [breadcrumb]);

  const handlePathConvertor = (item) => {
    let temp = item;
    temp = temp.split("-");
    temp[0] && temp[0] === "fr" && (temp[0] = "First Report");
    temp = item.startsWith("DPF") ? temp.join("-") : temp.join(" ");
    return temp;
  };
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      style={{ marginBottom: "10px", marginTop: "10px" }}
    >
      {navPath &&
        navPath.map((item, index) => {
          return item !== "" ? (
            <Link key={index} color="inherit">
              <span
                className={navPath.length === index + 1 ? classes.bold : ""}
              >
                {item === "app" ? (
                  <span
                    onClick={() => handleClick(item)}
                    style={{ cursor: "pointer" }}
                  >
                    Home
                  </span>
                ) : (
                  <span onClick={() => handleNav(item)}>
                    {" "}
                    {handlePathConvertor(item)}{" "}
                  </span>
                )}
              </span>
            </Link>
          ) : null;
        })}
    </Breadcrumbs>
  );
};

export default withRouter(BreadCrumb);
